import SageScreen from "kit/SageScreen";
import React from "react";
import FileListPage from "./fileList/FileListPage";

const FileList: React.FC = () => {
    const [page, setPage] = React.useState(0);

    const increment = React.useCallback(() => {
        setPage(page + 1);
    }, [page, setPage]);

    const decrementPage = React.useCallback(() => {
        setPage(Math.max(0, page - 1));
    }, [page, setPage]);

    return (
        <SageScreen>
            <h2>Your Files</h2>
            <p>
                These are the files that you have uploaded to Rend A Hand. You
                can download them or create your jobs with them.
            </p>
            <FileListPage
                page={page}
                increment={increment}
                decrement={decrementPage}
            />
        </SageScreen>
    );
};

export default FileList;
